import { render, staticRenderFns } from "./accessHistory.vue?vue&type=template&id=c4c140f2&"
import script from "./accessHistory.vue?vue&type=script&lang=js&"
export * from "./accessHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports